__turbopack_context__.v({
  "className": "NISnlq_className",
  "variable": "NISnlq_variable",
});
